import { Component, h } from 'preact';
import { I } from 'intl';
import { TcrModalView } from './modal-view';

class TcrPromptBox extends Component
{
    constructor(props)
    {
        super(props);

        this.onModalSave = this.onModalSave.bind(this);
        this.onModalDiscard = this.onModalDiscard.bind(this);
        this.onClose = this.onClose.bind(this);
        this.show = this.show.bind(this);
    }

    componentDidMount()
    {
        window.PromptBox = {
            show: this.show
        };
    }

    show(options)
    {
        return new Promise((resolve) => {
            let state = {
                visible: true,
                title: '',
                saveLabel: undefined,
                item: {},
                layout: [],
                actions: [{title: 'OK', default: true}],
                next: resolve
            };
            if (options.title) state.title = options.title;
            if (options.actions) state.actions = options.actions;
            if (options.item) state.item = options.item;
            if (options.layout) state.layout = options.layout;
            if (options.saveLabel) state.saveLabel = options.saveLabel;
            this.setState(state);
        });
    }

    async onModalDiscard()
    {
        return true;
        //ask for confirmation and return result
        // let choice = await window.MessageBox.show({
        //     title: 'Änderungen verwerfen',
        //     text: 'Sind sie sicher, dass sie ihre Änderungen verwerfen möchten?',
        //     actions: [{title: 'Verwerfen'}, {title: 'Abbrechen'}]
        // });
        // return choice === 0;
    }

    async onModalSave(id, changes)
    {
        if (typeof this.state.next == 'function') this.state.next(changes);
        this.setState({next: undefined});
        return true;
    }

    async onClose()
    {
        console.log('on close');
        if (typeof this.state.next == 'function') this.state.next(false);
        this.setState({visible: false, item: undefined, layout: undefined, next: undefined});
    }

    render()
    {
        if (!this.state.visible) return;

        return (
            <TcrModalView title={this.state.title} saveLabel={this.state.saveLabel} item={this.state.item} layout={this.state.layout} onSave={this.onModalSave} onClose={this.onClose} onDiscard={this.onModalDiscard} />
        );
    }
}

export { TcrPromptBox };